import JSONbig from 'json-bigint';
import { ApiError } from 'shared/model/types';

export const getFirstError = (error: ApiError) => error?.data.errors?.[0];
export const getErrorId = (error: ApiError) => error?.data?.errors?.[0]?.id || '';
export const getSecondErrorId = (error: ApiError) => error?.data?.messages?.[0]?.id || undefined;
export const getErrorDefaultMessage = (error: ApiError) => {
  return error?.data?.errors?.[0].defaultMessage || undefined;
};

export const bigIntResponseHandler = (response: Response) => {
  const JSONbigString = JSONbig({ storeAsString: true });

  return response.text().then((res) => {
    return JSONbigString.parse(res);
  });
};

export const retryOperation = async <T, P extends any[]>(
  operation: (...args: P) => Promise<T | { data?: T; isError?: boolean; error?: any }>,
  attempts: number,
  ...args: P
): Promise<T> => {
  let lastError: any = null;

  for (let i = 0; i < attempts; i++) {
    try {
      const result = await operation(...args);

      if (result && typeof result === 'object' && 'isError' in result) {
        if (result.isError) {
          lastError = result.error as ApiError;
          throw new Error(
            `Attempt ${i + 1} failed, error: ${
              getErrorDefaultMessage(lastError) || 'Unknown Error'
            }`,
          );
        }

        return result.data!;
      }

      return result as T;
    } catch (error) {
      console.log(error);
      lastError = error;
    }
  }

  throw lastError;
};
